import FeaturedPropertyCard from "@/components/sections/FeaturedPropertyCard";

interface Listing {
  image: string;
  status?: string;
  price: string;
  priceNote?: string;
  address: string;
  beds?: number;
  baths?: number;
  sqft?: string;
  href?: string;
  logo?: string;
}

interface PropertyGridProps {
  listings: Listing[];
  columns?: 2 | 3 | 4;
}

const colsClass = {
  2: "md:grid-cols-2",
  3: "md:grid-cols-2 lg:grid-cols-3",
  4: "md:grid-cols-2 lg:grid-cols-4",
};

const PropertyGrid = ({ listings, columns = 3 }: PropertyGridProps) => {
  return (
    <div className={`grid grid-cols-1 ${colsClass[columns]} gap-8 md:gap-10`}>
      {listings.map((listing, i) => (
        <FeaturedPropertyCard key={i} {...listing} />
      ))}
    </div>
  );
};

export default PropertyGrid;
